import React from "react";

// Default components
import {defaultComponents} from "./../components/_default/interfaces/DefaultComponents"
import ContentRenderer from "./../components/_default/ContentRenderer"
import MetadataComponent from "./../components/_default/MetadataComponent";
import CheckNotFoundPage from "./../components/_default/CheckNotFoundPage";
import { useAppSelector, useAppDispatch } from "./../store/hooks"

window.defaultComponents = defaultComponents;

export default function Webpage414teset() {
        const page_seo = {
                    seo_title: 'teset - testprana.itpr.eu',
                    canonical: 'https:\/\/testprana.itpr.eu\/et\/tset',
            }
    
    const dispatch = useAppDispatch();
    
    React.useEffect(() => {
        dispatch({
            type: "SET_WEBPAGE_ACTIVE",
            payload: "019c89f4-e11f-7e1d-9499-9343d9bf66f9"
        });
    }, [])
    
    React.useEffect(() => {
        dispatch({
            type: "UPDATE_STRUCTURE",
            payload: {"webpageComponents":[10416],"components":{"10416":{"id":10416,"uuid":"019c7a2d-43e6-7bc7-96af-02a6c9d34712","language_id":null,"parent_id":null,"webpage_id":414,"type":"section","sort_order":0,"version":1,"isShared":false,"attributes":{"classes":"row","content_width_unit":"%","content_width_size":100,"styles":{"paddingTop":"60px","paddingLeft":"60px","paddingRight":"60px","paddingBottom":"60px"}},"childWebpageComponentRelations":[]}}}        });
    }, [])
    
    
    
    return (
        <>
            <CheckNotFoundPage/>
            <MetadataComponent page_seo={page_seo} />
            <ContentRenderer />
        </>
    );
}